<template>
  <v-card style="margin: auto !important;">
    <v-container class="container">
      <v-form v-model="formValid">
      <v-row cols="12">
          <v-col cols="6">
            <v-text-field
              v-model="form.firstName"
              label="Jméno" outlined
              :rules="[rules.required]"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="form.lastName"
              label="Příjmení" outlined
              :rules="[rules.required]"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-select
              ref="dietSelect"
              label="Vyberte jídelníček"
              :items="diets"
              item-text="name"
              return-object
             :disabled="currentUser.roleId === 6"
              v-model="form.diet" outlined
              :rules="[rules.required]"
            ></v-select>
          </v-col>
        <v-col cols="12">
          <v-select
            ref="institutionSelect"
            label="Vyberte instituci"
            :items="institutions"
            item-value="id"
            item-text="name"
            v-model="form.institutionId"
            outlined
            :disabled="currentUser.roleId === 6"
            :rules="[rules.required]"
          ></v-select>
        </v-col>

        <v-checkbox label="Přihlašování" v-model="form.loggable"></v-checkbox>
      </v-row>
          <v-row v-if="form.loggable" cols="12">
            <v-col cols="12">
              <v-text-field
                v-model="form.email"
                label="Login" outlined
                :rules="this.form.loggable ? [rules.required, rules.email] : []"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="form.password"
                :rules="[rules.minLength(6)].concat(!boarder.id && this.form.loggable ? [rules.required] : [])"
                :type="show1 ? 'text' : 'password'"
                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="show1 = !show1"
                label="Heslo" outlined></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                color="green"
                v-model="form.passwordConfirmation"
                :rules="[formRules.passwordConfirmation].concat(!boarder.id && this.form.loggable ? [rules.required] : [])"
                :type="show2 ? 'text' : 'password'"
                :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="show2 = !show2"
                label="Heslo znovu"
                outlined
              ></v-text-field>
            </v-col>
          </v-row>
          <v-btn
            :disabled="!formValid || wait"
            color="warning"
            class="mr-4"
            @click="save"
          >
            Zapsat
          </v-btn>
      </v-form>
    </v-container>
  </v-card>
</template>

<script>
import rules from '../../../mixins/rules'
import { mapGetters } from 'vuex'

export default {
  mixins: [rules],
  props: ['boarder', 'availableDiets', 'userId', 'institutions'],
  name: 'AddBoarderForm',
  data () {
    return {
      wait: false,
      show1: false,
      show2: false,
      formValid: true,
      form: {
        ...this.boarder,
        districts: [],
        foodTypes: [],
        password: '',
        passwordConfirmation: '',
        loggable: !!this.boarder.email,
        roleId: 7
      },
      formRules: {
        passwordConfirmation: v => v === this.form.password || 'Zadejte prosím stejné heslo.'
      }
    }
  },
  methods: {
    save () {
      this.wait = true
      const options = {
        method: this.boarder.id ? 'put' : 'post',
        url: `/admin/users${this.boarder.id ? '/' + this.boarder.id : ''}`,
        data: this.keysToSnakeCase(this.form)
      }
      this.$http(options)
        .then(response => {
          const options = {
            method: 'post',
            url: `/admin/users/${response.data.id}/diets`,
            data: { diets: [this.form.diet] }
          }
          this.$http(options)
            .then(response => {
              this.wait = false
              this.$emit('data-saved')
            })
            .catch(err => { console.log(err) })
        })
        .catch(err => {
          this.wait = false
          if (err.response.status === 422) {
            alert('E-mail je již používán.')
          }
        })
    }
  },
  computed: {
    diets () {
      if (!this.form.institutionId) {
        return this.availableDiets
      }
      return this.availableDiets
        .filter(diet => diet.institutionId === this.form.institutionId)
    },
    ...mapGetters({ currentUser: 'user/currentUser' })
  },
  watch: {
    'form.loggable': function () {
      if (!this.form.loggable) {
        this.form.email = ''
        this.form.password = ''
        this.form.passwordConfirmation = ''
      }
    },
    'form.institutionId': function (val) {
      if (this.form.diet) {
        if (this.form.diet.institutionId !== val) {
          this.form.diet = null
        }
      }
    },
    'form.diet': function (val) {
      if (val) {
        if (val.institutionId !== this.form.institutionId) {
          this.form.institutionId = null
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
